import { getTVL } from "@services/index";
import { useQuery } from "@tanstack/react-query";

type TVLType = {
  value: number;
  usdTvl: number;
  usdPrice: number;
  symbol: string;
  name: string;
};

export type TVLDataType = {
  tvl: TVLType | undefined;
};

const useTVL = () => {
  const { data: tvlData } = useQuery({
    queryKey: ["tvl"],
    queryFn: async () => {
      const r = await getTVL();
      return r.data;
    },
    staleTime: 10 * 1000,
    refetchInterval: 10 * 1000,
    refetchOnMount: false,
    refetchIntervalInBackground: false,
    placeholderData: (previousData) => previousData,
  });

  return {
    tvl: tvlData as TVLType,
  };
};

export default useTVL;
